/* eslint-disable react/display-name */

import React from 'react';
import AppContext from '../contexts/app';

export default (AppConsumer) => (props) => (
  <AppContext.Consumer>
    {(context) => (
      <AppConsumer {...props} {...context} />
    )}
  </AppContext.Consumer>
);
